import get from 'lodash/get';
export default function cancelAlertsActionCreator(userDuck, personalization) {
  return id => async (dispatch, getState) => {
    // get current saved search object
    try {
      const cancelAlertsEvent = await personalization.cancelAlerts(id);
      if (cancelAlertsEvent.userId) {
        dispatch(userDuck.creators.setGlobalAlert({
          key: 'cancelAlertsSuccess'
        }));
        const {
          user
        } = getState();
        const bookmarks = get(user, 'bookmarks.inventoryBookmarks', {});
        const bookmarkIds = userDuck.selectors.getSavedInventoryIds({
          user
        });
        const updatedBookmarks = {
          ...bookmarks
        };
        bookmarkIds.forEach(inventoryId => {
          updatedBookmarks[inventoryId] = {
            ...bookmarks[inventoryId],
            hasTextAlerts: false,
            hasEmailAlerts: false
          };
        });
        dispatch(userDuck.creators.setInventoryBookmarks(updatedBookmarks));
      } else {
        // show server error message
        dispatch(userDuck.creators.setGlobalAlert({
          key: 'serverFailure',
          message: cancelAlertsEvent.message
        }));
      }
    } catch (error) {
      dispatch(userDuck.creators.setGlobalAlert({
        key: 'serverFailure',
        message: error
      }));
      throw Error(error);
    }
  };
}